// Keep desktop anchoring unchanged; never fight a finger or momentum scroll.
export const isMobileChatList = () => window.matchMedia('(max-width: 750px)').matches;
export type ScrollActivity = { touching:boolean; lastScroll:number; position?:number };
export const canRestoreChatScroll = (activity:ScrollActivity, now=Date.now(), element?:HTMLElement) => {
 if(!isMobileChatList())return true;
 if(element && activity.position!==element.scrollTop){
  activity.position=element.scrollTop;
  activity.lastScroll=now;
 }
 return !activity.touching && now-activity.lastScroll>800;
};
export function trackChatScroll(element:HTMLElement, activity:ScrollActivity){
 const start=()=>{if(isMobileChatList())activity.touching=true;};
 const end=()=>{activity.touching=false;activity.lastScroll=Date.now();};
 const scroll=()=>{if(isMobileChatList())activity.lastScroll=Date.now();};
 element.addEventListener('touchstart',start,{passive:true});
 element.addEventListener('touchend',end,{passive:true});
 element.addEventListener('touchcancel',end,{passive:true});
 element.addEventListener('scroll',scroll,{passive:true});
 return ()=>{
  element.removeEventListener('touchstart',start);
  element.removeEventListener('touchend',end);
  element.removeEventListener('touchcancel',end);
  element.removeEventListener('scroll',scroll);
 };
}
